export default __webpack_public_path__ + "static/media/23-breathe.654213d5.png";